import { t } from 'i18next';

import { AssignManufacturerCell } from 'bom/elements';
import { IManufacturerOption } from 'bom/types';
import { getPossibleManufacturerOptions } from 'bom/utils';
import { SwitchCell } from 'core/elements';

import PossibleManufacturerCell from './PossibleManufacturerCell';

export const getColumnDefs = (isAlternateVersionEnabled: boolean) => [
  {
    colId: 'part',
    headerName: t('headerPartNumber'),
    field: 'number',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  },
  {
    colId: 'description',
    headerName: t('headerDescription'),
    field: 'description',
    maxWidth: 400,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    cellRendererParams: {
      maxRows: 4,
    },
  },
  {
    colId: 'possibleManufacturers',
    headerName: t('headerPossibleManufacturers'),
    field: 'possibleManufacturers',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    valueGetter: ({ data }) =>
      data?.possibleManufacturers
        .map(
          (option: IManufacturerOption) => `${option.manufacturerName} ${option.partDescription}`
        )
        .join(' '),
    cellRenderer: PossibleManufacturerCell,
  },
  {
    colId: 'manufacturer',
    headerName: t('headerAssignManufacturer'),
    field: 'manufacturer',
    sortable: false,
    cellRendererSelector: ({ data }) => {
      return {
        component: AssignManufacturerCell,
        params: {
          options: getPossibleManufacturerOptions(data?.possibleManufacturers),
          isAlternateVersionEnabled,
        },
      };
    },
  },
  {
    colId: 'omit',
    headerName: t('headerOmit'),
    field: 'omit',
    sortable: false,
    minWidth: 100,
    width: 100,
    maxWidth: 100,
    cellRenderer: SwitchCell,
    cellRendererParams: {
      colId: 'omit',
    },
  },
  {
    colId: 'doNotAssignManufacturer',
    headerName: t('headerDoNotAssignManufacturer'),
    field: 'doNotAssignManufacturer',
    sortable: false,
    maxWidth: 150,
    cellRenderer: SwitchCell,
    cellRendererParams: {
      colId: 'doNotAssignManufacturer',
    },
  },
];
